import styled from 'styled-components'

const BannerTopStyle = styled.div`
	--aboutUsBannerPaddingTop: 50.8%;
	--bannerTitleMarginBottom: var(--sp4x);
	--contentWrapBottom: var(--sp13x);
	--titleMaxWidth: 50%;

	.title-wrap {
		overflow: hidden;
	}

	.addStyle {
		max-width: var(--titleMaxWidth);
	}

	.black-layer {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--primaryColor2);
		z-index: 100;
	}

	.banner-wrap {
		position: relative;
		padding-top: var(--aboutUsBannerPaddingTop);

		.about-us-banner {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			padding-top: var(--aboutUsBannerPaddingTop);
		}

		.layer {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			padding-top: var(--aboutUsBannerPaddingTop);
			background-color: var(--primaryColor2);
			opacity: 50%;
			z-index: 1;
		}

		.content-wrap {
			position: absolute;
			width: 100%;
			z-index: 2;
			bottom: var(--contentWrapBottom);

			.content-wrap-title {
				margin-bottom: var(--bannerTitleMarginBottom);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		--h2: 164px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--aboutUsBannerPaddingTop: 50.6%;
		--bannerTitleMarginBottom: var(--sp3x);
		--contentWrapBottom: var(--sp11x);
		--titleMaxWidth: 50%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--aboutUsBannerPaddingTop: 57.3%;
		--bannerTitleMarginBottom: var(--sp2x);
		--contentWrapBottom: var(--sp8x);
		--titleMaxWidth: 50%;
		--h2: 92px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--aboutUsBannerPaddingTop: 52.4%;
		--bannerTitleMarginBottom: var(--sp2x);
		--contentWrapBottom: var(--sp7x);
		--titleMaxWidth: 45%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--aboutUsBannerPaddingTop: 59.4%;
		--bannerTitleMarginBottom: var(--sp2x);
		--contentWrapBottom: var(--sp6x);
		--titleMaxWidth: 42%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--aboutUsBannerPaddingTop: 53.7%;
		--bannerTitleMarginBottom: var(--sp2x);
		--contentWrapBottom: var(--sp5x);
		--titleMaxWidth: 47%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--aboutUsBannerPaddingTop: 71.7%;
		--bannerTitleMarginBottom: var(--sp2x);
		--contentWrapBottom: var(--sp4x);
		--titleMaxWidth: 48%;
		--h2: 48px;

		.values-wrap {
			.value-item {
				&:first-child {
					padding-left: 0;
				}

				&:last-child {
					padding-right: 0;
				}
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--aboutUsBannerPaddingTop: 108.7%;
		--bannerTitleMarginBottom: var(--sp2x);
		--contentWrapBottom: var(--sp4x);
		--titleMaxWidth: 45%;

		--h2: var(--sp4x);

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.MobileSizeS}) {
			--titleMaxWidth: 50%;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSizeSMin}) {
			--h2: var(--sp3-5x);
		}
	}
`

export default BannerTopStyle
